/**
 * operation actions
 */

export const OP_GET_GLOBAL_DATA = 'OP_GET_GLOBAL_DATA';
export const OP_GET_GLOBAL_DATA_SUCCESS = 'OP_GET_GLOBAL_DATA_SUCCESS';
export const OP_GET_GLOBAL_DATA_FAIL = 'OP_GET_GLOBAL_DATA_FAIL';

export const OP_GET_SEGMENT_DATA = 'OP_GET_SEGMENT_DATA';
export const OP_GET_SEGMENT_DATA_SUCCESS = 'OP_GET_SEGMENT_DATA_SUCCESS';
export const OP_GET_SEGMENT_DATA_FAIL = 'OP_GET_SEGMENT_DATA_FAIL';

export const OP_GET_INSEGMENT_DATA = 'OP_GET_INSEGMENT_DATA';
export const OP_GET_INSEGMENT_DATA_SUCCESS = 'OP_GET_INSEGMENT_DATA_SUCCESS';
export const OP_GET_INSEGMENT_DATA_FAIL = 'OP_GET_INSEGMENT_DATA_FAIL';

export const OP_GET_ANALYST_DATA = 'OP_GET_ANALYST_DATA';
export const OP_GET_ANALYST_DATA_SUCCESS = 'OP_GET_ANALYST_DATA_SUCCESS';
export const OP_GET_ANALYST_DATA_FAIL = 'OP_GET_ANALYST_DATA_FAIL';

export const OP_GET_ANALYST_THROUGHPUT = 'OP_GET_ANALYST_THROUGHPUT';
export const OP_GET_ANALYST_THROUGHPUT_SUCCESS =
  'OP_GET_ANALYST_THROUGHPUT_SUCCESS';
export const OP_GET_ANALYST_THROUGHPUT_FAIL = 'OP_GET_ANALYST_THROUGHPUT_FAIL';

export function getFigureData(payload) {
  return {
    type: OP_GET_GLOBAL_DATA,
    payload
  };
}

export function getFigureDataSuccess(payload) {
  return {
    type: OP_GET_GLOBAL_DATA_SUCCESS,
    payload
  };
}

export function getSegmentsData(payload) {
  return {
    type: OP_GET_SEGMENT_DATA,
    payload
  };
}

export function getSegmentsDataSuccess(payload) {
  return {
    type: OP_GET_SEGMENT_DATA_SUCCESS,
    payload
  };
}

export function getInSegmentData(payload) {
  return {
    type: OP_GET_INSEGMENT_DATA,
    payload
  };
}

export function getInSegmentDataSuccess(payload) {
  return {
    type: OP_GET_INSEGMENT_DATA_SUCCESS,
    payload
  };
}

export function getAnalystData(payload) {
  return {
    type: OP_GET_ANALYST_DATA,
    payload
  };
}

export function getAnalystDataSuccess(payload) {
  return {
    type: OP_GET_ANALYST_DATA_SUCCESS,
    payload
  };
}

export function getAnalystThroughput(payload) {
  return {
    type: OP_GET_ANALYST_THROUGHPUT,
    payload
  };
}

export function getAnalystThroughputSuccess(payload) {
  return {
    type: OP_GET_ANALYST_THROUGHPUT_SUCCESS,
    payload
  };
}
